module.exports = __webpack_public_path__ + "static/media/home2.1a42b112.jpg";